export default __webpack_public_path__ + "static/SpainsunderwatersuperplantDesktop-7d579365d7ad098ef5920f043ef4f245.jpg";